import {FormGroup, FormControl, Validators} from '@angular/forms';
import {AlertController, NavController, ModalController} from 'ionic-angular';
import {Component} from '@angular/core';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {BackendModule} from '../../../../../modules/backend.module';
import {MembershipService} from '../membership.service';
import {SessionService} from '../../../../../services/session';
import {LocationsService} from '../../../../../services/locations';
import {TabsService} from '../../../tabs.service';
import {AuthService} from '../../../../../services/auth';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'page-new-complement',
  templateUrl: 'new-complement.html'
})
export class NewComplementPage {
  coupon = '';
  unprocessedCoupon = false; //this is to make sure user validated coupon
  couponValid = false;
  membershipForm = new FormGroup({});
  now = new Date();
  currentYear = this.now.getFullYear();
  showPaymentsIframe = false;
  acceptCLTerms = false;

  // socket: any;
  browser: any;
  intervalID: number;
  isBuying = false;

  constructor(
    public alertCtrl: AlertController,
    public sessionService: SessionService,
    public backendModule: BackendModule,
    public membershipService: MembershipService,
    public locationsService: LocationsService,
    public navCtrl: NavController,
    public tabsService: TabsService,
    public iab: InAppBrowser,
    public modalCtrl: ModalController,
    public authService: AuthService
  ) {
  }

  ngOnInit() {
    this.membershipForm = new FormGroup({
      acceptTerms: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  ngOnDestroy() {
  }

  validateCoupon() {
    this.unprocessedCoupon = false;
    this.backendModule
      .postAPI(`coupons/validate`, {
        coupon_name: this.coupon,
        user_id: this.sessionService.user.id,
        plan: this.membershipService.beautyPlanName
      })
      .subscribe(
        (result: any) => {
          if (!result.valid) {
            this.couponValid = false;
            this.membershipService.beautyFinalPrice = this.membershipService.beautyMembershipPrice;
            let alert = this.alertCtrl.create({
              title: 'Cupón ' + this.locationsService.translate('invalid'),
              buttons: [
                {
                  text: 'OK',
                  handler: () => {
                    this.coupon = '';
                  }
                }
              ]
            });
            alert.present();
          }
          if (result.valid) {
            this.couponValid = true;
            this.membershipService.beautyFinalPrice =
              this.membershipService.beautyMembershipPrice -
              this.membershipService.beautyMembershipPrice *
              (result.coupon.discount / 100.0);

            this.membershipService.beautyCouponName = result.coupon.name;
          }
        },
        err => {
          this.sessionService.reportError(
            'newComplementPage',
            'validateCoupon()',
            err
          );
        }
      );
  }

  confirmSubscription() {
    // MX and chile
    if (!this.couponValid && this.coupon !== '') {
      this.unprocessedCoupon = true;
      this.alertCtrl.create({
        title: 'Tienes un cupón sin validar',
        cssClass: 'red-text-alert',
        buttons: [
          {
            text: 'Regresar',
            role: 'cancel'
          },
          {
            text: 'Validar',
            handler: () => {
              this.validateCoupon();
            }
          }
        ]
      }).present();
      return;
    }

    const paymentProcessor = this.locationsService.country === 'MX' ? this.membershipService.processor :
      this.locationsService.translate('paymentProcessor');

    const product = 'beauty';
    this.isBuying = true;

    const amount = this.membershipService.beautyFinalPrice.toFixed();

    // this.socket = this.backendModule.openSocket()
    const urlToLoad: string = encodeURI(`${this.membershipService.paymentsUrl}?` +
      `processor=${paymentProcessor}` +
      `&plan=${product}` +
      `&user_id=${this.sessionService.user.id}` + `&amount=${amount}` +
      `&time=${new Date().getTime()}` + `&coupon=${this.membershipService.beautyCouponName}` +
      `&country=${this.locationsService.versionService.country}`)

    const windowProxy = this.openBrowser(urlToLoad);
    this.verifyPurchase(windowProxy);
  }

  async getLastIncome(): Promise<any> {
    const params = new HttpParams()
      .append('pagination[page]', '1')
      .append('pagination[count]', '1');

    return this.backendModule.getAPI('incomes', {
      observe: 'response',
      params: params
    }).toPromise().then((response: any) => {
      if (response.body.data && response.body.data.length) {
        return response.body.data[0];
      }
    });
  }

  openBrowser(url) {
    return window.open(url, '_blank', 'location=yes');
  }

  verifyPurchase(windowProxy: Window) {
    const currentDate = new Date();

    this.intervalID = window.setInterval(() => {
      this.getLastIncome()
        .then((lastIncome: any) => {
          if (lastIncome == null) {
            return;
          }

          if (lastIncome.product !== 'beauty') {
            return;
          }

          const lastIncomeCreatedAt = new Date(lastIncome.created_at);
          console.debug(
            'Comparing incomes',
            'Current Date', currentDate.valueOf(),
            'last Income Date', lastIncomeCreatedAt.valueOf()
          );


          if (lastIncomeCreatedAt.valueOf() > currentDate.valueOf()) {
            console.log('Purchase detected', lastIncomeCreatedAt);
            window.clearInterval(this.intervalID);
            this.completePurchase();

            windowProxy.close();
          }
        })
        .catch(error => {
          console.error('Could n\'t get the last income');
          console.error(error);
        })
    }, 2000);
  }

  async completePurchase() {
    this.isBuying = false;
    window.clearInterval(this.intervalID);

    await this.authService.getUserInfo(this.sessionService.user.id);
    await this.navCtrl.popToRoot();
    this.navCtrl.parent.select(this.tabsService.BEAUTY);
  }

  retryPurchase() {
    this.isBuying = false;
    window.clearInterval(this.intervalID);
  }

  ionViewWillLeave() {
    window.clearInterval(this.intervalID);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/new-complement/new-complement.ts